import React from "react";

export default function BackArrow() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3006 11.3079H6.39059L9.79059 7.90786C9.92755 7.77761 10.0051 7.59687 10.0051 7.40786C10.0051 7.21885 9.92755 7.03811 9.79059 6.90786C9.66034 6.7709 9.4796 6.69336 9.29059 6.69336C9.10158 6.69336 8.92084 6.7709 8.79059 6.90786L4.20059 11.5079C4.14341 11.5688 4.09311 11.6359 4.05059 11.7079C3.98053 11.881 3.98053 12.0747 4.05059 12.2479C4.08891 12.3408 4.13935 12.4282 4.20059 12.5079L8.80059 17.0979C8.93227 17.2322 9.11248 17.3079 9.30059 17.3079C9.48594 17.3086 9.66333 17.2326 9.79059 17.0979C9.92755 16.9676 10.0051 16.7869 10.0051 16.5979C10.0051 16.4088 9.92755 16.2281 9.79059 16.0979L6.39059 12.7079H19.3006C19.6872 12.7079 20.0006 12.3945 20.0006 12.0079C20.0006 11.6213 19.6872 11.3079 19.3006 11.3079Z"
        fill="#12344D"
      />
    </svg>
  );
}
